// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Laudos_UrlsCruasInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de GET /cli/Laudos_urls_cruas/run (DS 2026-0043, D4).
 * Todos os filtros são opcionais.
 */
import { registerContract } from './validate'

export interface Laudos_UrlsCruasInput {
franquia_id?: string
de?: string
ate?: string
limite?: string
}

registerContract('Laudos_UrlsCruasInput', {
  franquia_id: { type: 'string',  required: false },
  de:          { type: 'string',  required: false },
  ate:         { type: 'string',  required: false },
  limite:      { type: 'string',  required: false },
})
